import { ProjectTimeDetailGraphsDocument } from 'generated/resources/graphql'
import moment, { Moment } from 'moment'

import { useEffect } from 'modules/core/hooks/useEffect'
import { useQuery } from 'modules/core/hooks/useQuery'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import {
  graphViewsDetailViewOptionEnum,
  overviewFrequencyOptionsEnum,
} from 'modules/project_management/lib/constants'
import { maxLengthOfLabelsArray } from 'modules/project_management/lib/overviewOptions'

import { ResponsiveBarChart } from '../../ResponsiveBarChart'
import { DetailTransformedData, getDetailTransformedData } from '../getDistributionTransformedData'

interface TimeDistributionChartProps {
  projectId: number
  startDate?: Moment
  endDate?: Moment
  frequencySelected: overviewFrequencyOptionsEnum
  selectedOption: graphViewsDetailViewOptionEnum
}

const TimeDistributionChart = ({
  projectId,
  startDate = moment().startOf('week'),
  endDate = moment().endOf('week'),
  frequencySelected,
  selectedOption,
}: TimeDistributionChartProps) => {
  useEffect(() => {
    track(trackingEvents.projectManagement.overview.projectsOverviewGraphSelected, {
      graphType: selectedOption,
    })
  }, [selectedOption])

  const { loading, error, data } = useQuery(ProjectTimeDetailGraphsDocument, {
    variables: {
      projectId: projectId,
      startDate: startDate.format('YYYY-MM-DD'),
      endDate: endDate.format('YYYY-MM-DD'),
      slotType: frequencySelected,
      includeEmployee: selectedOption === 'employees',
      includeSubproject: selectedOption === 'subprojects',
    },
  })

  const projectTimeDetailGraphs = data?.projectManagement?.projectTimeDetailGraphs || []

  const transformedData: DetailTransformedData = getDetailTransformedData(
    projectTimeDetailGraphs,
    selectedOption,
    frequencySelected
  )

  const maxLabels = maxLengthOfLabelsArray(frequencySelected)

  return (
    <ResponsiveBarChart
      detailData={transformedData}
      unit={i18n.t('project_management.graphs.evolution.time.unit')}
      maxLabels={maxLabels}
      loading={loading}
      error={error}
    />
  )
}

export default TimeDistributionChart
